import React from "react";

export const APP_STORE_LINK =
  "https://apps.apple.com/us/app/rightwork/id6470950284";
export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.wstewart15.rightwork";

const MobileScreenWarning = () => {
  const isIOS =
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isAndroid = /Android/.test(navigator.userAgent);

  // Order the buttons by detected platform so the most likely correct option
  // is the primary CTA. Both are always shown so users with non-standard user
  // agents (in-app webviews, browsers in spoof modes) can still pick.
  const iosBtn = {
    key: "ios",
    href: APP_STORE_LINK,
    label: "Download for iPhone",
  };
  const androidBtn = {
    key: "android",
    href: PLAY_STORE_LINK,
    label: "Download for Android",
  };
  const ordered = isAndroid ? [androidBtn, iosBtn] : [iosBtn, androidBtn];

  return (
    <div className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-md p-8 text-center">
        <img
          src="https://rightworkpublic.s3.us-west-1.amazonaws.com/logo_name.png"
          alt="Rightwork"
          className="h-7 mx-auto mb-6"
        />

        <h2 className="text-xl font-semibold text-slate-900 mb-2">
          Get the Rightwork app
        </h2>
        <p className="text-slate-500 mb-6 leading-relaxed">
          Download the app to view your schedule, message your team, complete training, and much more.
        </p>

        <div className="flex flex-col gap-3">
          {ordered.map((btn, idx) => (
            <a
              key={btn.key}
              href={btn.href}
              target="_blank"
              rel="noopener noreferrer"
              className={
                idx === 0
                  ? "block w-full py-3 px-4 rounded-xl bg-violet-700 hover:bg-violet-800 text-white font-medium transition-colors"
                  : "block w-full py-3 px-4 rounded-xl border border-slate-300 text-slate-700 hover:bg-slate-50 font-medium transition-colors"
              }
            >
              {btn.label}
            </a>
          ))}
        </div>

        <p className="text-slate-400 text-xs mt-6">
          On a desktop? Resize your browser window to use the web app.
        </p>
      </div>
    </div>
  );
};

export default MobileScreenWarning;
